export default __webpack_public_path__ + "4dd32cdb5c4b5ef2f4b9b01229510de8.png";